import '../../CSS/private/Form.css';
import FormDetails from './FormDetails';

function FormSelect(props)
{
  const value = props.value;
  const setValue = props.setValue;
  const placeholder = props.placeholder;

  const formDetails = <FormDetails required={props.required} title={props.title} description={props.description} />

  return (
    <div className='slp-form slp-form-input'>
      {formDetails}
      <select placeholder={placeholder} defaultValue={value} onChange={(e) => {setValue(e.target.value)}} disabled={props.disabled} >
        {props.addNull? (
          <option value={null} />
        ) : null}
        {props.children}
      </select>
    </div>
  )
}

export default FormSelect;